import React from 'react';
import Carousel from 'nuka-carousel';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import iconRight from '@fortawesome/fontawesome-free-solid/faAngleDoubleRight';
import iconLeft from '@fortawesome/fontawesome-free-solid/faAngleDoubleLeft';

import koltechLogo from '../assets/img/koltech-logo.png';
import koltechPerson from '../assets/img/koltech-person.jpeg';
import gorzyceLogo from '../assets/img/gorzyce-logo.png';
import gorzycePerson from '../assets/img/gorzyce-person.jpg';
import ekooknaLogo from '../assets/img/ekookna-logo.png';
import ekooknaPerson from '../assets/img/adam_wajda.jpg';

export default props => (
  <section className="team-1" id="testimonials">
    <div className="container">
      <div className="row">
        <div className="col-md-8 col-md-offset-2 text-center">
          <h1>Osoby które skorzystały z naszych usług</h1>
        </div>
      </div>
      <Carousel
        framePadding="40px 0"
        frameOverflow="visible"
        heightMode="current"
        cellSpacing={300}
        renderCenterRightControls={({ nextSlide }) => (
          <span onClick={nextSlide} name="nextSlide">
            <FontAwesomeIcon icon={iconRight} size="2x" />
          </span>
        )}
        renderCenterLeftControls={({ previousSlide }) => (
          <span onClick={previousSlide} name="previousSlide">
            <FontAwesomeIcon icon={iconLeft} size="2x" />
          </span>
        )}
      >
        <div className="row clients">
          <div className="col-sm-12 col-md-3 col-md-offset-1">
            <div className="circle">
              <img src={ekooknaPerson} alt="" />
            </div>
            <h5>Adam Wajda </h5>
            <span>
              Dyrektor ds. administracyjno-organizacyjnych<br /> Eko-Okna S.A.
            </span>
          </div>
          <div className="col-sm-12 col-md-7 review">
            <img src={ekooknaLogo} alt="" />
            <p>
              Podczas współpracy z Panem Markiem Krupa bardzo podniósł się poziom bezpieczeństwa naszej firmy, w tym
              świadomość pracowników.
            </p>
          </div>
        </div>
        <div className="row clients">
          <div className="col-sm-12 col-md-3 col-md-offset-1">
            <div className="circle">
              <img src={koltechPerson} alt="" />
            </div>
            <h5>Adam Białuski </h5>
            <span>V-ce Prezes Zarządu</span>
          </div>
          <div className="col-sm-12 col-md-7 review">
            <img src={koltechLogo} alt="" />
            <p>
              Mogę przyznać, iż od momentu rozpoczęcia współpracy z Panem Markiem podniósł się znacznie poziom
              świadomości pracowników w zakresie bezpieczeństwa informacji oraz ochrony danych osobowych.
            </p>
          </div>
        </div>

        <div className="row clients">
          <div className="col-sm-12 col-md-3 col-md-offset-1">
            <div className="circle">
              <img src={gorzycePerson} alt="" />
            </div>
            <h5>Daniel Jakubczyk</h5>
            <span>Wójt Gminy Gorzyce</span>
          </div>
          <div className="col-sm-12 col-md-7 review">
            <img src={gorzyceLogo} alt="" />
            <p>
              Pan Marek Krupa pełni funkcje Administratora Bezpieczeństwa informacji w Urzędzie Gminy w Gorzycach od
              stycznia 2016 roku do nadal. Pan Marek Krupa posiada specjalistyczną wiedzę i predyspozycje do pełnienia
              funkcji Administratora Bezpieczeństwa Informacji, a w najbliższej przyszłości Inspektora Ochrony Danych.
            </p>
          </div>
        </div>
      </Carousel>
    </div>
  </section>
);



// WEBPACK FOOTER //
// ./src/components/Clients.js